import { Box, Radio, Typography, useTheme } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import {
  legalEntityOwnerSignupFormValidator,
  otpCodeValidator,
  phoneNumberValidator,
} from "../../../../../../formValidators/auth/signup";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import CommentDotInActive from "../../../../../../media/images/icons/commentDotInActive";
import { handleOwnerTypeRegister } from "../../../../../../redux/features/settingSlice";
import { fetcherPost } from "../../../../../../services/fetcher";
import { convertToFormData2 } from "../../../../../../utils/functions";
import CustomButton from "../../../../../components/CustomButton";
import CustomCheckbox from "../../../../../components/CustomCheckbox";
import CustomInput from "../../../../../components/CustomInput";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import OtpInput from "../../OtpInput";
import RulesModal from "../../RulesModal";

export default function LegalEntity() {
  const theme = useTheme();

  const { ownerTypeRegister } = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const [isvalidForm, setIsValidForm] = useState(false);
  const [otpState, setOtpState] = useState<boolean>(false);

  const [rules, setRules] = useState(false);

  const { trigger: registerTrigger } = useSWRMutation(
    [
      `/Account/OwnerLgRegister`,
      null,
      {
        "Content-Type": "multipart/form-data",
      },
    ],
    fetcherPost,
    {
      onSuccess: (data) => {
        const { access_token } = data;

        localStorage.setItem("access_token", access_token);

        navigate("/owner/dashboard");
      },
    }
  );

  const { trigger: verifyCodeTrigger } = useSWRMutation(
    [`/Account/DriverSignupSendCode`],

    fetcherPost,
    {
      onSuccess: (e) => {
        setOtpState(true);
      },
    }
  );

  const otpCodeFormik = useFormik({
    initialValues: {
      validationCode: "",
    },
    validationSchema: otpCodeValidator,
    onSubmit: () => {
      setOtpState(true);
    },
  });

  const verifyCodeFormik = useFormik({
    initialValues: {
      input: "",
    },
    validationSchema: phoneNumberValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      verifyCodeTrigger(values);
    },
  });

  const formik = useFormik({
    initialValues: {
      surName: "",
      CompanyNid: "",
      regCode: "",
      CompanyPostalCode: "",
      userName: "",
      ManagerMobile: "",
      foreName: "",
      rules: false,
      role: "NobatSender",
    },
    validationSchema: legalEntityOwnerSignupFormValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      const newValues = {
        ...values,
        ReqFile: "0",
        ManagerNc: values.userName,
        CompanyName: values.surName,
        ManagerName: values.foreName,
        phoneNumber: verifyCodeFormik.values.input,
        ManagerMobile: verifyCodeFormik.values.input,
        validationCode: otpCodeFormik.values.validationCode,
      };

      registerTrigger(convertToFormData2(newValues));
    },
  });

  useEffect(() => {
    verifyCodeFormik.validateForm().then((errors) => {
      if (Object.keys(errors).length > 0) {
        setIsValidForm(false);
      } else {
        setIsValidForm(true);
      }
    });
  }, [verifyCodeFormik.values]);
  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case "rules":
        formik.setFieldValue("rules", event.target.checked);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "bgColor.white",
        justifySelf: "center",
        boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
        paddingX: "10px",
        paddingY: "16px",
        borderRadius: "16px",
        marginX: "auto",
      }}
    >
      <RulesModal open={rules} handleClose={() => setRules(false)} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            color: "primary.main",
            textAlign: "center",
          }}
        >
          ثبت‌نام صاحب کالا
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Radio
              size="small"
              onClick={() => dispatch(handleOwnerTypeRegister("individual"))}
              checked={ownerTypeRegister === "individual"}
            />
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              فرد حقیقی هستم
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Radio
              size="small"
              onClick={() => dispatch(handleOwnerTypeRegister("legal-entity"))}
              checked={ownerTypeRegister === "legal-entity"}
            />
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              شرکت حقوقی هستم
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: "1",
            // overflow: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            px: 1,
          }}
        >
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"نام شرکت"}
            </CustomInputLabel>

            <CustomInput
              errorMessage={formik.touched.surName && formik.errors.surName}
              error={formik.touched.surName && Boolean(formik.errors.surName)}
              handelChange={formik.handleChange}
              value={formik.values.surName}
              name="surName"
              placHolder="نام شرکت را وارد کنید..."
            />
          </Box>
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"شناسه ملی"}
            </CustomInputLabel>

            <CustomInput
              type={"numeric"}
              errorMessage={
                formik.touched.CompanyNid && formik.errors.CompanyNid
              }
              error={
                formik.touched.CompanyNid && Boolean(formik.errors.CompanyNid)
              }
              handelChange={formik.handleChange}
              value={formik.values.CompanyNid}
              name="CompanyNid"
              placHolder="شناسه ملی (11 رقمی) را وارد کنید..."
            />
          </Box>
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کد ثبت"}
            </CustomInputLabel>

            <CustomInput
              type={"numeric"}
              errorMessage={formik.touched.regCode && formik.errors.regCode}
              error={formik.touched.regCode && Boolean(formik.errors.regCode)}
              handelChange={formik.handleChange}
              value={formik.values.regCode}
              name="regCode"
              placHolder="کد ثبت"
            />
          </Box>
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کدپستی شرکت"}
            </CustomInputLabel>

            <CustomInput
              type={"numeric"}
              errorMessage={
                formik.touched.CompanyPostalCode &&
                formik.errors.CompanyPostalCode
              }
              error={
                formik.touched.CompanyPostalCode &&
                Boolean(formik.errors.CompanyPostalCode)
              }
              handelChange={formik.handleChange}
              value={formik.values.CompanyPostalCode}
              name="CompanyPostalCode"
              placHolder="کد پستی شرکت"
            />
          </Box>
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کد ملی مدیرعامل"}
            </CustomInputLabel>

            <CustomInput
              type={"numeric"}
              errorMessage={formik.touched.userName && formik.errors.userName}
              error={formik.touched.userName && Boolean(formik.errors.userName)}
              handelChange={formik.handleChange}
              value={formik.values.userName}
              name="userName"
              placHolder="کدملی مدیرعامل را وارد کنید..."
            />
          </Box>
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"نام و نام‌خانوادگی مدیرعامل"}
            </CustomInputLabel>

            <CustomInput
              errorMessage={formik.touched.foreName && formik.errors.foreName}
              error={formik.touched.foreName && Boolean(formik.errors.foreName)}
              handelChange={formik.handleChange}
              value={formik.values.foreName}
              name="foreName"
              placHolder=" نام و نام خانوادگی مدیرعامل را وارد کنید..."
            />
          </Box>
          <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"تلفن همراه مدیرعامل"}
            </CustomInputLabel>

            <CustomInput
              type="tel"
              errorMessage={
                verifyCodeFormik.touched.input && verifyCodeFormik.errors.input
              }
              error={
                verifyCodeFormik.touched.input &&
                Boolean(verifyCodeFormik.errors.input)
              }
              name="input"
              handelChange={verifyCodeFormik.handleChange}
              value={verifyCodeFormik.values.input}
              placHolder="09121234567"
            />
          </Box>
          <CustomCheckbox
            name="rules"
            checked={formik.values.rules}
            handleChange={handleChangeCheckbox}
            errorMessage={formik.touched.rules && formik.errors.rules}
            error={formik.touched.rules && Boolean(formik.errors.rules)}
            label={
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                من تایید می‌کنم که{" "}
                <Link
                  onClick={() => setRules(true)}
                  style={{
                    color: theme.palette.primary.main,
                  }}
                  to={"#"}
                >
                  {"قوانین و مقررات"}
                </Link>{" "}
                را مطالعه کرده‌ام و شرایط بازارگاه کارن ترابر نت را می‌پذیرم.
              </Typography>
            }
          />
          {otpState && (
            <>
              <OtpInput
                name="validationCode"
                value={otpCodeFormik.values.validationCode}
                handleChange={otpCodeFormik.handleChange}
                errorMessage={
                  otpCodeFormik.touched.validationCode &&
                  otpCodeFormik.errors.validationCode
                }
                error={
                  otpCodeFormik.touched.validationCode &&
                  Boolean(otpCodeFormik.errors.validationCode)
                }
                sendOtpState={(isFinished) => setOtpState(!isFinished)}
              />
            </>
          )}

          <CustomButton
            disabled={!isvalidForm}
            // loading={loading}

            onClick={async () => {
              if (otpState) {
                const errors = await otpCodeFormik.validateForm();
                if (Object.keys(errors).length > 0) {
                  otpCodeFormik.setErrors(errors);
                  otpCodeFormik.handleSubmit();
                  console.log(Object.keys(errors));
                } else {
                  formik.handleSubmit();
                }
              } else {
                const errors = await formik.validateForm();
                if (Object.keys(errors).length > 0) {
                  formik.setErrors(errors);
                  formik.handleSubmit();
                } else {
                  verifyCodeFormik.handleSubmit();
                }
              }
            }}
            textColor={"#fff"}
            // borderColor="textColor.light"
            // type={!isvalidForm ? "outlined" : "contained"}
            flexDirection="row"
            title={
              !otpState
                ? "ارسال رمز یک‌بار مصرف به تلفن"
                : "تایید رمز و ثبت نام"
            }
            justifyContent="center"
            bgColor={isvalidForm ? "secondary.main" : "textColor.light"}
            width="100%"
            fSize="16px"
            fWeight="700"
            px="10px"
            py="10px"
            borderRadius="10px"
            icon1={!otpState && <CommentDotInActive size={20} />}
            mt="16px"
          />
        </Box>
      </Box>
    </Box>
  );
}
